export default __webpack_public_path__ + "static/media/BANNER_JENNY_UEBERBERG.ae50f89b.jpeg";